import { descending } from 'd3';
import { getSessionIdentity, bearerHeaders } from '../auth/descope';

export const LOAD_HISTORY = 'load_history';

export default (dispatch, getState) => {
  dispatch({ type: LOAD_HISTORY, data: 'Loading saved portfolios from DPD...' });

  const { params } = getState();
  const auth = getSessionIdentity();

  const url = `${process.env.REACT_APP_DPD_URL}/api/portfolio/find_overview/`;

  // If not signed in there is no Descope session, so skip loading
  if (auth.email) {

    fetch(`${url}?clientEmail=${encodeURIComponent(auth.email)}&wtRegion=${params.wtRegion}`, {
      headers: bearerHeaders(auth),
    })
      .then(d => {
        if (d.status === 404) {
          dispatch({ type: LOAD_HISTORY, data: [] })
        }
        return d.json()
      })
      .then(data => {
        const sortedData = [...data]
          .filter(p => !!p.holdings)
          .sort(
            (a, b) =>
              descending(a.favorite, b.favorite) ||
              descending(new Date(a.runDate), new Date(b.runDate))
          );
        dispatch({ type: LOAD_HISTORY, data: sortedData });
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: LOAD_HISTORY,
          data: 'Failed to load saved portfolios',
        });
      });
  }
  // If there is no valid session then don't load anything
  else {
    dispatch({ type: LOAD_HISTORY, data: [] })
  }
};
